import { Dialog, Box } from '@machobear/design-system'
import { DialogEventHandler } from '@/types'
import Content from './content'

import analytics from './analytics.png'
type Props = {
  visible: boolean
  closeModal: DialogEventHandler
  noFlag?: boolean
}

const AnalyticsReportModal = ({ visible, closeModal, noFlag }: Props) => {
  return (
    <Dialog
      id="AdvertiseYourListingModal"
      open={visible}
      onClose={closeModal}
      headerIllustration={<Box component="img" width="full" src={analytics} />}
    >
      <Content closeModal={closeModal} />
    </Dialog>
  )
}

export default AnalyticsReportModal
